import { createFeature, createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromReducer from '../reducers/search.reducer';

const state = createFeatureSelector<fromReducer.State>(fromReducer.searchFeatureKey);

export const selectQ = createSelector(state, state => state.q);
export const selectSearchResults = createSelector(state, state => state.searchResult);

export const selectActiveSearchResult = createSelector(state, state => state.activeItem);
export const selectActiveSearchResultPartId = createSelector(selectActiveSearchResult, result => result?.productID);
export const selectActiveSearchResultPartNumber = createSelector(selectActiveSearchResult, result => result?.partNumber);

export const selectResultWithObsoleteParts = createSelector(selectSearchResults, results => {
  const arr = results.map(r => r.partNumber).filter((v, i, a) => a.indexOf(v) === i)
  return arr.map(v => Object.assign({},
    { searchResult: results.find(f => f.partNumber === v) },
    { obsoletePartNumbers: results.filter(f => f.partNumber === v).filter(f => f.obsoletePartNumber.length > 0).map(a => a.obsoletePartNumber) }));
});

export const selectLoaders = createSelector(state, state => state.loaders);
export const selectLoader = (name: fromReducer.Loaders) =>
  createSelector(selectLoaders, (loaders: fromReducer.Loaders[]) => !!((loaders || []).find(f => f === name)));
